import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";

const QtnReviseModal = React.forwardRef((props, ref) => {
  const { show, onHide, onSubmit } = props; // ✅ FIX 1

  const [formInputs, setFormInputs] = useState({
    openingDateTime: "",
    remarks: "",
  });

  const handleSave = () => {
    onSubmit?.(formInputs); // ✅ FIX 2 (call parent function)
    onHide(); // ✅ optional: close modal
  };

  const extractValue = (input) => {
    if (typeof input === "string") return input;
    if (input?.target?.value) return input.target.value;
    if (input?.value) return input.value;
    return "";
  };

  const onInputChange = (name, input) => {
    const value = extractValue(input);

    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      centered
      keyboard={false}
      ref={ref}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-add"></i>
          <span className="modal-title"> Quotation Revise</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "16px" }}>
        {/* FORM */}
        <Row className="mb-3">
          <Col xs={12} md={6} className="pe-md-3">
            <InputField
              className="inputBox"
              label="Opening Date"
              type="date"
              name="openingDateTime"
              value={formInputs.openingDateTime}
              onChange={(input) => onInputChange("openingDateTime", input)}
            />
          </Col>

          <Col xs={12} md={6} className="ps-md-3">
            <TextAreaField
              className="inputBox"
              label="Remarks"
              name="remarks"
              rows={2}
              value={formInputs.remarks}
              onChange={(input) => onInputChange("remarks", input)}
            />
          </Col>
        </Row>

        {/* ACTION BUTTONS */}
        <Row className="pt-3 border-top">
          <Col className="d-flex justify-content-end gap-2">
            <button className="btnTable btn-danger" onClick={onHide}>
              Cancel
            </button>
            <button
              className="btnTable"
              onClick={handleSave} // ✅ FIX 3
            >
              Save
            </button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default QtnReviseModal;
